(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hd-product-card"] && !Shopify.designMode) return;
  try {
    /* Carrossel de mídia do card de produto.
     Tudo por delegação no document: os cards injetados por Section Rendering
     (recomendações, coleção com filtros, busca preditiva) funcionam sem re-init. */
  (function () {
    const ROOT = '[data-hd-card-media]';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    const root = (el) => (el && el.closest ? el.closest(ROOT) : null);
    const track = (r) => r.querySelector('[data-hd-track]');
    const slides = (r) => r.querySelectorAll('[data-hd-slide]');

    function currentIndex(r) {
      const t = track(r);
      const w = t.clientWidth || 1;
      return Math.round(t.scrollLeft / w);
    }

    function go(r, i, smooth) {
      const t = track(r);
      const total = slides(r).length;
      const target = Math.max(0, Math.min(i, total - 1));
      t.scrollTo({
        left: target * t.clientWidth,
        behavior: smooth && !reduced.matches ? 'smooth' : 'auto',
      });
      sync(r, target);
    }

    function sync(r, i) {
      const total = slides(r).length;
      const idx = typeof i === 'number' ? i : currentIndex(r);
      const prev = r.querySelector('[data-hd-card-prev]');
      const next = r.querySelector('[data-hd-card-next]');
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= total - 1;
      r.querySelectorAll('[data-hd-card-dot]').forEach((dot, n) => {
        if (n === idx) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    document.addEventListener('click', (e) => {
      const target = e.target;
      if (!target || !target.closest) return;
      const btn = target.closest('[data-hd-card-prev],[data-hd-card-next],[data-hd-card-dot]');
      if (!btn) return;
      const r = root(btn);
      if (!r) return;
      e.preventDefault();
      e.stopPropagation();
      r.dataset.hdManual = '1';
      if (btn.hasAttribute('data-hd-card-dot')) go(r, parseInt(btn.dataset.hdCardDot, 10), true);
      else go(r, currentIndex(r) + (btn.hasAttribute('data-hd-card-next') ? 1 : -1), true);
    });

    /* scroll não borbulha — capture pega o de qualquer trilho, inclusive os novos */
    document.addEventListener(
      'scroll',
      (e) => {
        const t = e.target;
        if (!t || !t.hasAttribute || !t.hasAttribute('data-hd-track')) return;
        const r = root(t);
        if (!r) return;
        clearTimeout(r._hdT);
        r._hdT = setTimeout(() => sync(r), 90);
      },
      true
    );

    /* Um arrasto não pode virar navegação p/ a PDP (mobile).
       Só arrasto de dedo marca o timestamp — o scroll programático (hover do
       desktop, setas, dots) não pode bloquear o clique legítimo no card. */
    document.addEventListener(
      'touchmove',
      (e) => {
        const t = e.target.closest && e.target.closest('[data-hd-track]');
        const r = t && root(t);
        if (r) r.dataset.hdScrolledAt = String(Date.now());
      },
      { capture: true, passive: true }
    );

    document.addEventListener(
      'click',
      (e) => {
        const link = e.target.closest && e.target.closest('[data-hd-track]');
        if (!link) return;
        const r = root(link);
        const at = r && Number(r.dataset.hdScrolledAt || 0);
        if (at && Date.now() - at < 350) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    /* Desktop: mantém a "2ª imagem no hover" enquanto o usuário não navegar */
    document.addEventListener('mouseover', (e) => {
      if (!finePointer.matches) return;
      const r = root(e.target);
      if (!r || r.dataset.hdHover === '1') return;
      r.dataset.hdHover = '1';
      if (r.dataset.hdManual === '1') return;
      if (slides(r).length > 1) go(r, 1, true);
    });

    document.addEventListener('mouseout', (e) => {
      if (!finePointer.matches) return;
      const r = root(e.target);
      if (!r || (e.relatedTarget && r.contains(e.relatedTarget))) return;
      delete r.dataset.hdHover;
      delete r.dataset.hdManual;
      go(r, 0, true);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hd-wishlist"] && !Shopify.designMode) return;
  try {
    (function () {
    const KEY = 'hd_wishlist';
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    const write = (items) => { localStorage.setItem(KEY, JSON.stringify(items)); };
    const has = (id) => read().some((i) => String(i.id) === String(id));

    const heartSVG =
      '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.8 6.2a5 5 0 0 0-7.1-.1L12 7.7l-1.7-1.6a5 5 0 0 0-7.1 7.1l1.1 1.1L12 21.5l7.7-7.2 1.1-1.1a5 5 0 0 0 0-7z"/></svg>';

    const dialog = document.getElementById('hd-wl-dialog');
    const listEl = dialog && dialog.querySelector('[data-hd-wl-list]');
    const emptyEl = dialog && dialog.querySelector('[data-hd-wl-empty]');
    const countTitle = dialog && dialog.querySelector('[data-hd-wl-count-title]');

    function syncBadge() {
      const n = read().length;
      const badge = document.querySelector('[data-hd-wl-badge]');
      if (badge) { badge.textContent = n; badge.hidden = n === 0; }
      if (countTitle) countTitle.textContent = n > 0 ? '(' + n + ')' : '';
    }

    function syncHearts() {
      document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
        const active = has(btn.dataset.id);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function renderList() {
      if (!listEl) return;
      const items = read();
      listEl.innerHTML = items
        .map(
          (i) =>
            '<li class="hd-wl-item">' +
            '<a class="hd-wl-item__media" href="' + i.url + '">' + (i.image ? '<img src="' + i.image + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div class="hd-wl-item__info">' +
            '<a class="hd-wl-item__title" href="' + i.url + '">' + i.title + '</a>' +
            (i.price ? '<span class="hd-wl-item__price">' + i.price + '</span>' : '') +
            '</div>' +
            '<button type="button" class="hd-wl-item__remove" data-hd-wl-remove="' + i.id + '" aria-label="Remover">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
            '</button>' +
            '</li>'
        )
        .join('');
      if (emptyEl) emptyEl.hidden = items.length > 0;
    }

    function openDialog() {
      renderList();
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    }

    function injectTrigger() {
      const actions = document.querySelector('header-actions');
      if (!actions || actions.querySelector('.hd-wl-trigger')) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'header-actions__action hd-wl-trigger';
      btn.setAttribute('aria-label', 'Meus favoritos');
      btn.innerHTML = heartSVG + '<span class="hd-wl-badge" data-hd-wl-badge hidden>0</span>';
      btn.addEventListener('click', openDialog);
      // insere à ESQUERDA do carrinho (o carrinho é a última ação nativa)
      const allActions = Array.from(actions.querySelectorAll(':scope > .header-actions__action'));
      let cartAction = allActions.find(
        (a) =>
          /cart|carrinho|bag|sacola/i.test(a.getAttribute('aria-label') || '') ||
          a.querySelector('[href*="cart"], cart-icon, [class*="cart"], [is*="cart"]')
      );
      if (!cartAction) cartAction = allActions[allActions.length - 1];
      if (cartAction) actions.insertBefore(btn, cartAction);
      else actions.appendChild(btn);
      syncBadge();
    }

    // Delegação: toggle no coração dos cards
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-wishlist-toggle]');
      if (toggle) {
        e.preventDefault();
        const id = toggle.dataset.id;
        let items = read();
        const idx = items.findIndex((i) => String(i.id) === String(id));
        if (idx >= 0) items.splice(idx, 1);
        else
          items.unshift({
            id: id,
            title: toggle.dataset.title || '',
            url: toggle.dataset.url || '#',
            image: toggle.dataset.image || '',
            price: toggle.dataset.price || '',
          });
        write(items);
        syncHearts();
        syncBadge();
        renderList();
        return;
      }
      const remove = e.target.closest('[data-hd-wl-remove]');
      if (remove) {
        const id = remove.dataset.hdWlRemove;
        write(read().filter((i) => String(i.id) !== String(id)));
        syncHearts();
        syncBadge();
        renderList();
        return;
      }
      if (e.target.closest('[data-hd-wl-close]')) {
        if (dialog) dialog.close();
      }
    });

    function init() {
      injectTrigger();
      syncHearts();
      syncBadge();
    }
    document.addEventListener('DOMContentLoaded', init);
    init();
  })();
  } catch(e) { console.error(e); }
})();

})();
